import React from "react";
import { Header } from "../../components/header";

type Props = {
	locationURL: string
	fxRates: {currRateBuy: string, currRateSell: string, currCode: string, inpDate: string}[]
	baseCurrency: string
}

const FixingRates: React.FC<Props> = props => {
	return (		
		<div id="page">
			<div id="center" >
				<Header location={props.locationURL} />
				<div id="content">
					<p className="codelist-header">
						{props.fxRates && props.fxRates.length > 0 
							? props.baseCurrency + " Fixing Rates for Customer FX Instructions on " + props.fxRates[0].inpDate 
								: "No data found."
						}
					</p>
					{props.fxRates && props.fxRates.length > 0 && (
					<table id={props.fxRates[0].currRateBuy ? 'fxratesBuySell' : 'fxrates'} >
							<tbody>						
								<tr className="datatable-row-white">
									<td className="column-fxrates-center"> </td>
									<td className="column-fxrates-right"><strong>Buy</strong></td>
									<td className="column-fxrates-center"> </td>						
									<td className="column-fxrates-right"><strong>Sell</strong></td>
								</tr>
								{props.fxRates.map((fxRate, index) =>
									<tr className={index % 2 ? "datatable-row-grey" : "datatable-row-white"}>
										<td className="column-fxrates-center">1 {props.baseCurrency} = </td>
										<td className="column-fxrates-right">{fxRate.currRateBuy}</td>
										<td className="column-fxrates-center">{fxRate.currCode}</td>
										<td className="column-fxrates-right">{fxRate.currRateSell}</td>
										<td className="column-fxrates-center">{fxRate.currCode}</td>
									</tr>
								)}
							</tbody>
					</table>
					)}
				</div>
			</div>
		</div>
	)
}

export default FixingRates